import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ApiCallMethodsService } from 'src/app/shared/services/api-call-methods.service';
import { DialogData } from '../sell-list/sell-list.component';
import { apiRoutes } from 'src/app/constants/apiRoutes';
import * as moment from 'moment';
import { DateFilterFn } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-payment-popup',
  templateUrl: './payment-popup.component.html',
  styleUrls: ['./payment-popup.component.scss']
})
export class PaymentPopupComponent {
  paymentForm: FormGroup;
  invoiceId: any;
  invoiceNumber: any;
  currentDate: any;
  today: Date = new Date();
  amountDue: any;
  dataPopUp: any;
  transId: any = null;
  paymentValue: any;
  editMode: boolean = false;
  amountPaid: any;
  dueAmount: any;
  dueEditPop: any;
  orderId: any = null;
  finacialData: any;
  invoiceList: any;
  invoiceDetails: any;
  iqpId: any;
  isFullPayment: boolean = false;
  orgId: any = null;
  companyProfileDetails: any = null;
  valuePan: any;
  isLoaderOn: boolean = false;
  isClosing: boolean = false;
  orgDetails: any = null;
  attachedFile: { name: string, size: string, type: string } | null = null;
  docUrl: string | null = null;
  docName: string | null = null;
  docType: string | null = null;
  isUploading: boolean = false;
  selectedFile: File | null = null;

  isDragging = false;

  triggerFileInput(input: HTMLInputElement) {
    input.click();
  }

  onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]);
    }
  }

  generateFileKey(file: File): string {
    const timestamp = Date.now();
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';

    for (let i = 0; i < 9; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      randomString += chars[randomIndex];
    }

    return `${timestamp}-${randomString}-`;
  }

  uploadFileToS3(file: File): Observable<any> {
    this.isUploading = true;
    const extension = file.name.split('.').pop()?.toLowerCase() || '';
    const fileKey = this.generateFileKey(file);
    const newFileName = `${Date.now()}-${fileKey}temp_payment_${Date.now()}.${extension}`;
    const renamedFile = new File([file], newFileName, { type: file.type });

    const url = `${apiRoutes.imageUpload}?filename=${encodeURIComponent(renamedFile.name)}&folder=payments&contentType=${encodeURIComponent(renamedFile.type)}`;

    return new Observable(observer => {
      this.apiCallMethodsService.get(url).subscribe({
        next: (response: any) => {
          const presignedUrl = response?.data?.url;
          if (!presignedUrl) {
            this.isUploading = false;
            observer.error(new Error('Failed to generate upload URL.'));
            return;
          }

          fetch(presignedUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': renamedFile.type
            },
            body: renamedFile
          }).then(res => {
            if (res.ok) {
              const docUrl = presignedUrl.split('?')[0];
              const docName = file.name;
              const docType = file.type.includes('pdf') ? 'pdf' : (file.type.includes('image') ? 'img' : 'file');
              this.isUploading = false;
              observer.next({ docUrl, docName, docType });
              observer.complete();
            } else {
              this.isUploading = false;
              observer.error(new Error('Upload failed: ' + res.statusText));
            }
          }).catch(err => {
            this.isUploading = false;
            observer.error(err);
          });
        },
        error: (error: any) => {
          this.isUploading = false;
          observer.error(error);
        }
      });
    });
  }

  handleFile(file: File) {
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) {
      this.alertService.failureAlert('Invalid file type. Only PNG, JPG, JPEG, and PDF are supported.');
      return;
    }
    
    const maxSizeInBytes = 4 * 1024 * 1024; // 4MB
    if (file.size > maxSizeInBytes) {
      this.alertService.failureAlert('File size exceeds the 4MB limit.');
      return;
    }

    this.selectedFile = file;
    this.attachedFile = {
      name: file.name,
      size: (file.size / 1024 / 1024).toFixed(2) + ' MB',
      type: file.type
    };
  }

  removeAttachment() {
    this.attachedFile = null;
    this.selectedFile = null;
    this.docUrl = null;
    this.docName = null;
    this.docType = null;
  }

  getRemainingDue(): number {
    const enteredAmount = +this.paymentForm.get('iqp_partly_pmnt_amnt')?.value || 0;
    const base = this.editMode ? +this.dueAmount : +this.amountDue;
    return Math.max(0, base - enteredAmount);
  }

  constructor(
    private formBuilder: FormBuilder,
    private apiCallMethodsService: ApiCallMethodsService,
    private alertService: AlertService,
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PaymentPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dateAdapter: DateAdapter<Date>,

  ) {
    this.dataPopUp = data;
    this.invoiceId = data?.id;
    this.orderId = data?.orderId;
    this.orgDetails = authService.getSessionDetail();
    this.transId = data?.transactionId;
    this.invoiceNumber = data?.invNumber;
    this.amountDue = data?.amount;    
    this.dueAmount = data?.amount;
    this.currentDate = new Date();
    console.log(this.dataPopUp);
    

    this.paymentForm = this.formBuilder.group({
      iqp_payment_type: new FormControl('', Validators.compose([Validators.required])),
      iqp_payment_ref: new FormControl('', Validators.compose([])),
      iqp_paid_date: new FormControl(this.currentDate, Validators.compose([])),
      notes: new FormControl('', Validators.compose([])),
      wo_id: new FormControl(this.orderId, Validators.compose([])),
      payment_against: new FormControl(this.orderId, Validators.compose([])),
      iqp_partly_pmnt_amnt: new FormControl('', Validators.compose([Validators.required])),
    });

    if (this.transId !== undefined) {
      this.getPaymentDetails();
      this.getCompanyDetails();
      this.editMode = true;
    } else {
      this.getCompanyDetails();
    }

    this.orgId = this.authService.getId();
    dateAdapter.setLocale("en-in"); 
  }

  get paymentMethodOptions(): any[] {
    const opts: any[] = [
      { label: 'Cash', value: 'Cash' }
    ];

    if (this.companyProfileDetails?.org_bank_details?.length > 0) {
      this.companyProfileDetails.org_bank_details.forEach((bank: any) => {
        opts.push({
          label: `Bank Payment - ${bank?.bank_account_number}`,
          value: 'Bank Payment',
          paymentAgainst: bank?.bank_account_number
        });
      });
    } else {
      opts.push({ label: 'Bank Payment', value: 'Bank Payment' });
    }

    const panLabel = this.companyProfileDetails?.pan ? `TDS Payment - ${this.companyProfileDetails.pan}` : 'TDS Payment';
    opts.push({
      label: panLabel,
      value: 'TDS Payment Method',
      paymentAgainst: this.companyProfileDetails?.pan
    });

    opts.push({ label: 'Other Payment Method', value: 'Other Payment Method' });

    return opts;
  }

  onPaymentMethodChange(val: any) {
    this.paymentForm.patchValue({ iqp_payment_type: val });
    const matched = this.paymentMethodOptions.find(o => o.value === val);
    if (matched && matched.paymentAgainst) {
      this.methodValue(matched.paymentAgainst);
    }
  }

  onAmountKeyDown(event: KeyboardEvent) {
    this.validateAnnualCtc(event);
  }
  endDateFilter: DateFilterFn<Date | null> = (date: Date | null): boolean => {
    const startDate = this.paymentForm.get('iqp_paid_date')?.value as Date | null;

    if (!startDate) {
      return true; // Allow all dates if there is no start date
    }

    return date !== null && date >= startDate;
  };

  checkIfAmountExceeds(): boolean {
    const enteredAmount = +this.paymentForm.get('iqp_partly_pmnt_amnt').value;
    const amountDue = +this.amountDue;
    if (isNaN(enteredAmount)) {
      return true;
    }
    return enteredAmount >= amountDue + 0.001;
  }

  checkIfDueAmountExceeds(): boolean {
    const enteredAmount = +this.paymentForm.get('iqp_partly_pmnt_amnt').value;
    const amountDue = +this.dueAmount;
    if (isNaN(enteredAmount)) {
      return true;
    }
    return enteredAmount > amountDue + 0.001;
  }

  paymentFormSubmit() {
    this.isLoaderOn = true;

    const proceedSubmit = () => {
      let date = new Date(this.paymentForm.value.iqp_paid_date);
      this.paymentForm.value.iqp_paid_date = moment(`${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`, 'YYYY/MM/DD').format('YYYY/MM/DD');
      this.paymentForm.value.payment_against = this.valuePan;
      this.paymentForm.value.doc_url = this.docUrl || null;
      this.paymentForm.value.doc_type = this.docType || null;
      this.paymentForm.value.doc_name = this.docName || null;

      if (this.invoiceId != null) {
        let url = apiRoutes.amountPayment + '/' + this.invoiceId + '?org_id=' + this.orgId + '&user_id=' + this.orgDetails?.user?.user_id;
        this.apiCallMethodsService.post(url, this.paymentForm.value).subscribe((response: any) => {
          this.closeWithAnimation(response);
          this.isLoaderOn = false;
        }, (error: any) => {
          this.isLoaderOn = false;
          this.alertService.failureAlert(error.error.message);
        });
      }

      if (this.orderId != null) {
        let url = apiRoutes.amountPayment + '/' + this.iqpId + '?org_id=' + this.orgId + '&user_id=' + this.orgDetails?.user?.user_id;
        this.apiCallMethodsService.post(url, this.paymentForm.value).subscribe((response: any) => {
          this.closeWithAnimation(response);
          this.isLoaderOn = false;
        }, (error: any) => {
          this.isLoaderOn = false;
          this.alertService.failureAlert(error.error.message);
        });
      }
    };

    if (this.selectedFile) {
      this.uploadFileToS3(this.selectedFile).subscribe({
        next: (res) => {
          this.docUrl = res.docUrl;
          this.docName = res.docName;
          this.docType = res.docType;
          proceedSubmit();
        },
        error: (err) => {
          this.isLoaderOn = false;
          this.alertService.failureAlert(err.message || 'File upload failed.');
        }
      });
    } else {
      proceedSubmit();
    }
  }

  getPaymentDetails() {
    let url = apiRoutes.amountPayment + '/' + this.transId + '?org_id=' + this.orgId + '&user_id=' + this.orgDetails?.user?.user_id;
    this.apiCallMethodsService.get(url).subscribe((response: any) => {
      this.paymentValue = response?.data[0];
      const originalPaymentAmount = +this.paymentValue?.iqp_partly_pmnt_amnt || 0;
      this.dueAmount = (+response?.due[0]?.amount || 0) + originalPaymentAmount;

      this.paymentForm.patchValue({
        iqp_payment_type: this.paymentValue?.iqp_payment_type,
        iqp_payment_ref: this.paymentValue?.iqp_payment_ref,
        iqp_paid_date: this.paymentValue?.iqp_paid_date,
        notes: this.paymentValue?.notes,
        iqp_partly_pmnt_amnt: this.paymentValue?.iqp_partly_pmnt_amnt,
        payment_against: this.paymentValue?.payment_against,
      });

      this.valuePan =  this.paymentValue?.payment_against;

      if (this.paymentValue?.doc_url) {
        this.docUrl = this.paymentValue.doc_url;
        this.docName = this.paymentValue.doc_name || 'Attached File';
        this.docType = this.paymentValue.doc_type || 'file';
        this.attachedFile = {
          name: this.docName,
          size: '',
          type: this.docType
        };
      }

      if (this.paymentValue && this.paymentValue.length > 0) {
        this.paymentValue.forEach((payment: any) => {
          if (payment.iqp_paid_date) {
            payment.iqp_paid_date = this.formatDate(payment.iqp_paid_date);
          }
        });
      }

    })
  }

  formatDate(inputDate: string): string {
    const date = new Date(inputDate);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1; // Month is zero-based
    const year = date.getUTCFullYear();

    // Ensure two-digit format for day and month
    const formattedDay = day < 10 ? '0' + day : day;
    const formattedMonth = month < 10 ? '0' + month : month;

    return formattedDay + '/' + formattedMonth + '/' + year;
  }

  selectInvoice(invoice) {
    console.log(invoice);
    this.invoiceDetails = invoice;
    this.invoiceNumber = invoice?.iqp_invoice_number;
    this.amountDue = invoice?.amount;
    this.iqpId = invoice?.iqp_id;

    
  }

  methodValue(method: any = null){
    this.paymentForm.value.payment_against = method;
    this.valuePan = method;
  }

  paymentFormEdit() {
    this.isLoaderOn = true;

    const proceedEdit = () => {
      let date = new Date(this.paymentForm.value.iqp_paid_date);
      this.paymentForm.value.iqp_paid_date = moment(`${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`, 'YYYY/MM/DD').format('YYYY/MM/DD');
       
      if(this.paymentForm.value.iqp_payment_type == 'TDS Payment Method' && this.companyProfileDetails?.pan != ''){
        this.paymentForm.value.payment_against = this.companyProfileDetails?.pan;
      }
      if(this.paymentForm.value.iqp_payment_type == 'TDS Payment Method' && this.companyProfileDetails?.pan == ''){
        this.paymentForm.value.payment_against = this.valuePan;
      }

      let url = apiRoutes.amountPayment + '/' + this.transId + '?org_id=' + this.orgId + '&user_id=' + this.orgDetails?.user?.user_id;
      this.paymentForm.value.status = 100; // Processing — regular edit/update
      this.paymentForm.value.doc_url = this.docUrl || null;
      this.paymentForm.value.doc_type = this.docType || null;
      this.paymentForm.value.doc_name = this.docName || null;
      this.apiCallMethodsService.put(url, this.paymentForm.value).subscribe((response: any) => {
        this.closeWithAnimation(response);
        this.isLoaderOn = false;
      }, (error: any) => {
        this.isLoaderOn = false;
        this.alertService.failureAlert(error.error.message);
      });
    };

    if (this.selectedFile) {
      this.uploadFileToS3(this.selectedFile).subscribe({
        next: (res) => {
          this.docUrl = res.docUrl;
          this.docName = res.docName;
          this.docType = res.docType;
          proceedEdit();
        },
        error: (err) => {
          this.isLoaderOn = false;
          this.alertService.failureAlert(err.message || 'File upload failed.');
        }
      });
    } else {
      proceedEdit();
    }
  }
  getFinancialList() {
    let url = apiRoutes.worOrderFinancial + '/' + this.orderId;
    let payload = null;
    this.apiCallMethodsService.post(url, payload).subscribe((response: any) => {
      this.invoiceList = response?.Invoice;
      this.invoiceList = this.invoiceList?.filter(invoice => invoice?.amount !== '0.00');

    })
  }

  toggleFullPayment(event: any) {
    if (typeof event === 'boolean') {
      this.isFullPayment = event;
    }
    console.log(this.isFullPayment, this.amountDue, this.dueAmount);
    if (this.isFullPayment) {
      if (!this.editMode) {
        this.paymentForm.patchValue({
          iqp_partly_pmnt_amnt: this.amountDue
        });
      } else {
        this.amountDue = this.dueAmount;
        this.paymentForm.patchValue({
          iqp_partly_pmnt_amnt: this.dueAmount
        });
      }
    } else {
      this.paymentForm.patchValue({
        iqp_partly_pmnt_amnt: ''
      });
      if (!this.editMode) {
        this.amountDue = this.amountDue;
      }
    }
  }

  
  getCompanyDetails() {
    let url = apiRoutes.selectedOrgProfile + '/' + this.orgId;
    this.apiCallMethodsService.get(url).subscribe((response: any) => {
      this.companyProfileDetails = response?.data?.orgProfile;
      console.log(this.companyProfileDetails);

    })
  }
  onNoClick(): void {
    this.closeWithAnimation();
  }

  closeWithAnimation(response?: any) {
    this.isClosing = true;
    setTimeout(() => {
      this.dialogRef.close(response);
    }, 300);
  }


 validateAnnualCtc(event: KeyboardEvent) {
  const inputChar = event.key;
  const input = event.target as HTMLInputElement;
  const currentValue = input.value;

  // Allow control keys (backspace, arrows, etc.)
  if (event.ctrlKey || event.metaKey || ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(inputChar)) {
    return;
  }

  if (!/[\d.]/.test(inputChar)) {
    event.preventDefault();
    return;
  }

  if (inputChar === '.' && currentValue.includes('.')) {
    event.preventDefault();
    return;
  }

  const [integerPart, decimalPart] = currentValue.split('.');
  if (decimalPart && decimalPart.length >= 2 && input.selectionStart! > currentValue.indexOf('.')) {
    event.preventDefault();
    return;
  }
}

}
